import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import page components
import HomePage from './pages/HomePage';
import PenetrationTestingPage from './pages/services/PenetrationTestingPage';
import VulnerabilityAssessmentPage from './pages/services/VulnerabilityAssessmentPage';
import SecurityConsultingPage from './pages/services/SecurityConsultingPage';
import ComplianceAuditingPage from './pages/services/ComplianceAuditingPage';
import IncidentResponsePage from './pages/services/IncidentResponsePage';
import SecurityTrainingPage from './pages/services/SecurityTrainingPage';
import EnterpriseSecurityPage from './pages/solutions/EnterpriseSecurityPage';
import CloudSecurityPage from './pages/solutions/CloudSecurityPage';
import NetworkSecurityPage from './pages/solutions/NetworkSecurityPage';
import ApplicationSecurityPage from './pages/solutions/ApplicationSecurityPage';
import DataProtectionPage from './pages/solutions/DataProtectionPage';
import IdentityManagementPage from './pages/solutions/IdentityManagementPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services/penetration-testing" element={<PenetrationTestingPage />} />
        <Route path="/services/vulnerability-assessment" element={<VulnerabilityAssessmentPage />} />
        <Route path="/services/security-consulting" element={<SecurityConsultingPage />} />
        <Route path="/services/compliance-auditing" element={<ComplianceAuditingPage />} />
        <Route path="/services/incident-response" element={<IncidentResponsePage />} />
        <Route path="/services/security-training" element={<SecurityTrainingPage />} />
        <Route path="/solutions/enterprise-security" element={<EnterpriseSecurityPage />} />
        <Route path="/solutions/cloud-security" element={<CloudSecurityPage />} />
        <Route path="/solutions/network-security" element={<NetworkSecurityPage />} />
        <Route path="/solutions/application-security" element={<ApplicationSecurityPage />} />
        <Route path="/solutions/data-protection" element={<DataProtectionPage />} />
        <Route path="/solutions/identity-management" element={<IdentityManagementPage />} />
      </Routes>
    </Router>
  );
}

export default App;